<template>
    <div class="widget-container">
      
      <div class="password">
        <div class="dx-field-item">
          <div class="dx-field-item-label dinesafe-lightgold">Password:*</div>

          <div class='dx-field-item-content dsvt-form-item'>            
              <DxTextBox
                  name="txtNewPassword"
                  class="dsvt-form-item"
                  placeholder="••••••••"  
                  :show-clear-button="false"
                  mode="password"
                  stylingMode="underlined"
                  :read-only="true"
                  value="12345678"
              />         
          </div>
        </div>

        <div class="buttons dx-field-item">
          <div class="button dx-field-item-content">
            <DxButton ref="submitButtonRef" 
              class="change-password-button"
              width="100%"
              type="normal"
              text="Change Password"
              styling-mode="contained"
              :visible="true"
              @click="btnChangePasswordClick()"
            />
          </div>
        </div>
      </div>

      <form
        action="your-action"
        @submit="onSubmitClick"
      >
      <DxForm
        id="form"
        ref="contactInfoFormRef"
        
        :form-data.sync="accountInfo"
        :read-only="readOnly"
        :show-colon-after-label="showColon"
        :label-location="labelLocation"
        :min-col-width="minColWidth"
        action="your-action"
      >
        <DxGroupItem
          :col-count="4"
        >
          <!-- AJT ToDo - Use a v-for to loop through items in json -->
          <!-- Loop through the json items, and create input boxes in the form for each item -->
          <DxSimpleItem 
            v-for="item in adminSettingsData" :key="item.AttributeId"
            :data-field="item.Question"
            :label="{
              text: item.DisplayText,
              visible: true,
            }"
            
            :editor-options="{                              
                                //When Question = Phone, set the mask appropriately
                                mask: item.Question == 'Phone' ? '1 (000) 000-0000' : '',
                                showMaskMode: 'onFocus', //Only show the mask if the field has focus.  Without focus, the label shows
                                items: item.Question == 'State' ? states : null,
                                stylingMode:'underlined',
                                text: item.Question == 'PasswordButton' ? 'Change Password' : null,
                                mode: item.Question == 'Email' ? 'email' 
                                  : item.Question == 'Phone' ? 'tel'
                                  : 'text', //default to text
                                onClick: item.Question == 'PasswordButton' ? btnChangePasswordClick : null,
                              }"         
            :col-span="item.ColumnSpan"
            :editor-type="item.Question == 'State' ? 'dxSelectBox' 
                                  : item.Question == 'PasswordButton' ? 'dxButton' : null"
          >
              <!-- Set the "required" value based on the value of Question.isRequired -->
              <DxRequiredRule v-if="item.IsRequired" :message="item.Question + ' is required'"  />
          </DxSimpleItem>
    </DxGroupItem>
  </DxForm>
  </form>

    <div class="buttons">
      <div class="button">
        <DxButton ref="submitButtonRef" 
          :width="120"
          type="success"
          text="Save"
          styling-mode="contained"
          :visible="true"
          @click="onSubmitClick()"
        />
      </div>
    </div>
  </div>
</template>
<script>

import {DxButton} from 'devextreme-vue';
import {DxForm, DxSimpleItem, DxCompareRule, DxLabel, DxGroupItem, DxRequiredRule, DxPatternRule, DxButtonItem, DxEmptyItem, DxItem} from 'devextreme-vue/form';
import service from '../../../src/data/contact-info-data';
import notify from 'devextreme/ui/notify';
import adminData from '../../../src/data/admin-data.js';
import DxTextBox from "devextreme-vue/text-box";
//import shared from '../../utils/contact-tracing-functions';

export default {
  components: {
    DxForm,
    DxButton,
    DxSimpleItem, 
    DxCompareRule,
    DxGroupItem,
    DxRequiredRule,
    DxButtonItem,
    DxItem,
    DxTextBox,
  },
  data() {
    const adminSettings = adminData.getAdminSettings();
    const states = service.getStates();
    return {
      adminSettingsData: adminData.getAdminSettings()[0].TestQuestions[0].questions,
      labelLocation: 'top',
      readOnly: false,
      showColon: true,
      minColWidth: 300,
      adminSettings: adminSettings,
      width: null,
      states:states,
      submitButtonOptions: {
        type: 'success',
        text: 'Submit',
        useSubmitBehavior: true
      },
      namePattern: /^[^0-9]+$/,
      stateOptions: {
        items: states
      },
      phoneOptions: { mask: '+1 (000) 000-0000' },

      accountInfo:[
        {
            Email: null,
            FirstName: null,
            LastName: null,
            PhoneNumber: null,
            Address: null,
            Address1: '',
            City: null,
            State: "VT",
            ZipCode: null,
            BusinessName: null,
            BusinessDesc: null,
            WebsiteURL: null,
            MenuURL: null,
        }
      ]
    };
  },
  created(){
    //Get the Account Information
    this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetAccountData',
      {       
          //AccountId: this.$store.state.data.currentAccountId,
          AccountId: localStorage.dinesafeAccountId,
          UserId: JSON.parse(localStorage.dinesafeUser).UserId,
      }
      ).then(function(data){         
          if(data.body != null && data.body != ''){
              var responseData = JSON.parse(data.body);      

              this.accountInfo = responseData[0];                  
          }
      });
  },
  methods:{
    btnChangePasswordClick(e){
      this.$router.push("/changepass");
    },
    /*
      Stored proc = pr_account_edit
    */
    onSubmitClick(e){
      //Validate the user inputs.
      //if (!e.validationGroup.validate().isValid) {
      if(!this.$refs.contactInfoFormRef.instance.validate().isValid)
      {
        return;
      }
                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'EditAccount',
                {                           
                    //AccountId: this.$store.state.data.currentAccountId,
                    AccountId: localStorage.dinesafeAccountId,
                    UserId: JSON.parse(localStorage.dinesafeUser).UserId,
                    FirstName: this.accountInfo.FirstName,
                    LastName: this.accountInfo.LastName,
                    PhoneNumber: this.accountInfo.PhoneNumber,          
                    Address: this.accountInfo.Address,
                    Address1: this.accountInfo.Address1 == null ? '' : this.accountInfo.Address1,
                    City: this.accountInfo.City,
                    StateProvince: this.accountInfo.State,
                    PostalCode: this.accountInfo.ZipCode,
                    BusinessName: this.accountInfo.BusinessName,
                    BusinessDesc: this.accountInfo.BusinessDesc,
                    WebsiteURL: this.accountInfo.WebsiteURL,
                    MenuURL: this.accountInfo.MenuURL,
                }
                ).then(function(data){         
                    if(data.body != null && data.body != ''){
                        var responseData = JSON.parse(data.body);      

                        var message = responseData[0].Message;

                        if(message == 'Success!'){
                            notify(
                            {
                                message: "Settings saved", 
                                type:"success", 
                                width:100, 
                                displayTime: 2000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });

                            //this.$router.push("/home");
                        }
                        else{
                            notify(
                            {
                                message: "There was an issue saving", 
                                type:"warning", 
                                width:100, 
                                displayTime: 3000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });
                        }
                    }
                });

      return;

      //Show feedback
      var success = true;
      var type = 'success';
      var toastMessage = 'Your info was saved';
      var toastWidth = 100;

      if(success)
      {        
       

      }
      else
      {      
        //The submit failed
        type = 'failure';
        toastMessage = 'There was an error saving your information';
        toastWidth = 200;
      }

      //Show the success/fail message
      notify(
          {message: toastMessage, 
          type:type, 
          width:toastWidth, 
          displayTime: 2000,
          position: {
          my: 'center bottom',
          at: 'center bottom'
        }}
      );

      //Prevent the form from closing
      //e.preventDefault();      
    },
    checkComparison() {
      return true;
    },
  }
};
</script>
<style scoped>

/* The Form widget */
.widget-container {
    padding: 20px;
    
    min-width: 300px;
    max-width: 500px;

    margin:auto;
    display: block;

    background-color: white;
    border-radius: 5px;
}
#form {
    margin-top: 25px;
}

.caption {
    font-size: 18px;
    font-weight: 500;
}

/* Buttons */
.buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.button {
  padding: 10px;
}

.password{
  display: flex;
}

.dsvt-form-item{
  display:flex;
  min-width: 0px;
  max-width: 230px;

  padding-right: 30px;
}

.change-password-button{
  display:flex;
  min-width: 0px;
}

</style>

